/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ConfigStates } from '../enums';

import type { SectionConfigItem } from '../entries';

export const checkItemVisibleInSection = <T>(section: SectionConfigItem<T> | null, itemId: T): boolean => {
    if (section) {
        return section.getItemState(itemId as string) === ConfigStates.Visible;
    }

    return true;
};

export const checkColumnVisibleInSection = <T>(section: SectionConfigItem<T> | null, columnField: T): boolean => {
    if (section) {
        return section.getColumnState(columnField as string) === ConfigStates.Visible;
    }

    return true;
};

export const checkActionVisibleInSection = <T>(section: SectionConfigItem<T> | null, actionNameOrId: T): boolean => {
    if (section) {
        return section.getActionState(actionNameOrId as string) === ConfigStates.Visible;
    }

    return true;
};

export const checkAdvancedFilterVisibleInSection = <T>(section: SectionConfigItem<T> | null, filterId: T): boolean => {
    if (section) {
        return section.getAdvancedFilterState(filterId as string) === ConfigStates.Visible;
    }

    return true;
};
